
const url = "https://nirogsathi-backend-s5uq5.ondigitalocean.app/api/v1";
// const url = "http://localhost:5000/api/v1";

export const getBaseUrl = () => {
  return url;
};
